import * as React from 'react'

import { ValidationOptions } from '~/components/form/validation'
import { InlineMessage } from '~/components/inline-message/InlineMessage'
import { Label } from '~/components/label/Label'
import { Link } from '~/components/link/Link'
import { cn } from '~/styled'

import { type LabelProps } from '../label/Label'
import { Description } from './FieldDescription'

export type FieldWrapperProps = {
  className?: string
  error?: string
  fieldId: string
  label: string
  prompt?: { link?: string; label: string; onClick?: () => void }
  description?: string
  required?: boolean
  hideLabel?: boolean
  appearance?: LabelProps['appearance']
}

export type FieldElementWrapperProps = Omit<FieldWrapperProps, 'fieldId'> & {
  name: string
  validation?: ValidationOptions
}

export const FieldWrapper = ({
  children,
  error,
  fieldId,
  label,
  prompt,
  description,
  required,
  hideLabel,
  appearance,
  ...rest
}: React.PropsWithChildren<FieldWrapperProps>) => (
  <div {...rest}>
    <div
      className={cn(
        'mb-3',
        'flex',
        'items-center',
        'justify-between',
        hideLabel && 'sr-only'
      )}
    >
      <Label htmlFor={fieldId} required={required} appearance={appearance}>
        {label}
      </Label>
      {prompt && (
        <Link href={prompt?.link} onClick={prompt?.onClick} size="sm">
          {prompt.label}
        </Link>
      )}
    </div>
    {description && <Description className="mb-3">{description}</Description>}
    {children}
    {error && <InlineMessage className="mt-2">{error}</InlineMessage>}
  </div>
)

FieldWrapper.displayName = 'FieldWrapper'
